exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pay-loading[data-v-56324f94]{display:flex;justify-content:center;padding-top:250px;margin-bottom:70px}.txt[data-v-56324f94]{overflow:hidden;color:#333;text-align:center;font-size:24px}.number[data-v-56324f94]{font-size:.94rem}", ""]);

// exports
